export const FilePreviewRouting = {
  path: "/filePreview",
  name: "filePreview",
  meta: { title: "小程序文件预览" },
  component: () => import(/* webpackChunkName: "join" */ "@/views/join/h5/file-preview/index.vue"),
  children: [],
};
